// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://ventanilla.srs.gob.sv/security-ext',
  adminUrl: 'https://ventanilla.srs.gob.sv/bpmadmin',
  coreBpmUrl: 'https://ventanilla.srs.gob.sv/core/ext',
  catalogosUrl: 'https://ventanilla.srs.gob.sv/api/ext',
  gestorDocumentalUrl: 'https://ventanilla.srs.gob.sv/docs/ext',
  reportesUrl: 'https://ventanilla.srs.gob.sv/reportes',
  colecturiaUrl: 'https://ventanilla.srs.gob.sv/pagos/ext',
  regExpUsuario: '^[0-9-_]+$',
  regExpCorreo: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$',
  regExpLetras: '^[a-zA-Z.]+$',
  regExAlfabetico: '^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ]+$',
  regExAlfanumerico: '^[a-zA-Z0-9 ]+$',
  regExTelefono: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*[^-]$',
  regExNumeros: '^[0-9]+$',
  regexNIT: '^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]{1}$',
  regExIniciales: '^[A-Z]+$',
  regExPasaporte: '^[a-zA-Z0-9-]+$',
  minLengthPass: 5,
  minLengthCodigo: 5,
  nombreSistema: 'Ventanilla Electrónica',
  minutosAntesRefreshToken: 2,
  minutosAntesInterceptorRefreshToken: 4,
  segundosModalRefreshToken: 30,
  longitudCodigoSeguridad: 5,
  maxFileSize: 209715200// 200 MB,
  // maxFileSize: 2097152 // 2 MB (demo),
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
 // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
